import { BACCARAT_STATISTICS_TYPES } from '../enums/constants';

export const bigRoadStatisticCreateHandler = (statisticList, statisticType) => {
  const result = [];
  let matrix = [];
  let index = 0;
  let firstType = null;

  if (statisticList && statisticList.length) {
    matrix = statisticList.reduce((acc, cur) => {
      if (cur !== null) {
        if (firstType === null) {
          firstType = cur.winType === 2 ? null : cur.winType;
          if (acc[index]?.length) {
            acc[index] = [...acc[index], cur.winType];
          } else {
            acc[index] = [cur.winType];
          }
        } else if (cur.winType === firstType || cur.winType === 2) {
          acc[index].push(cur.winType);
        } else {
          index += 1;
          firstType = cur.winType;
          acc[index] = [cur.winType];
        }
      }
      return acc;
    }, []);
  }

  let bigRoadCount;

  if (statisticType === BACCARAT_STATISTICS_TYPES.BIG_ROAD1) {
    bigRoadCount = 1;
  } else if (statisticType === BACCARAT_STATISTICS_TYPES.BIG_ROAD2) {
    bigRoadCount = 2;
  } else {
    bigRoadCount = 3;
  }

  const winnerTableHandler = () => {
    for (let j = 0; j < matrix?.length; j += 1) {
      for (let i = 0; i < matrix?.[j]?.length; i += 1) {
        if (j) {
          if (j === bigRoadCount && i === 1) {
            if (i + 1 - matrix[0].length === 1) {
              result.push({ roundData: { winType: 1 } });
            } else {
              result.push({ roundData: { winType: 0 } });
            }
          } else {
            if (!i && j > bigRoadCount) {
              if (matrix[j - 1].length === matrix[j - bigRoadCount - 1]?.length) {
                result.push({ roundData: { winType: 0 } });
              } else {
                result.push({ roundData: { winType: 1 } });
              }
            }
            if (i && j && j >= bigRoadCount) {
              if (
                matrix[j - bigRoadCount]?.length &&
                i + 1 - matrix[j - bigRoadCount].length === 1
              ) {
                result.push({ roundData: { winType: 1 } });
              } else {
                result.push({ roundData: { winType: 0 } });
              }
            }
          }
        }
      }
    }
  };

  if (matrix.length) {
    winnerTableHandler();
  }

  return result;
};
